import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './styles.module.css';

const ProductSwitch = ({
    asin, image, title, description, price, checked, onSelect,
}) => (
    <div
        className={classnames(styles.container, {[styles.checked]: checked})}
        onClick={(evt) => onSelect(asin, evt)}
        onKeyDown={(evt) => (evt.keyCode === 13 || evt.keyCode === 32) && onSelect(asin, evt)}
        tabIndex="0"
        role="radio"
        aria-checked={checked}
    >
        <div
            className={styles.image}
            style={{
                backgroundImage: `url(${image})`,
            }}
        />
        <div className={styles.content}>
            <h2>{title}</h2>
            <h3>
                <span />
                {price}
            </h3>
            <p>{description}</p>
        </div>
    </div>
);

ProductSwitch.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    price: PropTypes.string.isRequired,
    asin: PropTypes.string.isRequired,
    checked: PropTypes.bool,
};

ProductSwitch.defaultProps = {
    image: 'http://via.placeholder.com/500x500/?text=Image',
    checked: false,
};

export default ProductSwitch;
